exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n#reservations{max-width:1000px;margin:40px auto 0\n}\n#reservations table{width:100%;text-align:left;border-collapse:collapse;margin-bottom:20px\n}\n#reservations table tr{height:32px\n}\n#reservations table th{background:#ececec;font-size:1rem;color:#111\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-2842d79a","scoped":false,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/views/account/Reservations.vue
// module id = 249
// module chunks = 0